/**
 * Unique, country-specific intro copy for country trade profiles (SEO / thin-content mitigation).
 * Templates vary by available statistics so pages are not identical boilerplate.
 */
export function buildCountryTradeIntro(country, statistics) {
  const { name, code, region, continent } = country;
  const regionPhrase =
    region && continent ? `${region} (${continent})` : region || continent || 'its broader region';

  const avgTariff = statistics?.averageTariff > 0 ? statistics.averageTariff : null;
  const tariffCount = statistics?.tariffCount ?? 0;

  let dataSentence;
  if (avgTariff != null && tariffCount > 0) {
    dataSentence = `The charts and tables below aggregate AI-detected tariff and trade-policy signals for ${name}: an approximate ${avgTariff.toFixed(
      1
    )}% average where line-item rates exist in our corpus, drawn from ${tariffCount} tariff-related events currently in the database.`;
  } else if (tariffCount > 0) {
    dataSentence = `This profile currently surfaces ${tariffCount} tariff-related events from our news and document pipeline, alongside sanctions, bilateral deals, and legislation where we have structured records.`;
  } else {
    dataSentence = `Structured tariff line items may still be sparse in our database for ${name}; that usually reflects pipeline coverage and source language mix, not necessarily a lack of real-world trade friction. Figures refresh as new public sources are processed.`;
  }

  return `This page is an editorially framed trade-risk snapshot for ${name} (${code})—an economy in ${regionPhrase}. ${dataSentence} Start with the Global Trade Index (GTI) summary for a composite score, then review sector breakdowns, AI-extracted events (with outbound links to primary reporting where available), and recent deals or bills. For how we weight events and compute scores, read our methodology. For sourcing rules and corrections, see editorial standards. TradeRadar provides informational intelligence only—not legal, investment, or trading advice.`;
}
